import * as Rx from 'rxjs';

export class TableService {
  private loading$ = new Rx.BehaviorSubject<boolean>(false);

  public isLoading = () => this.loading$;

  public changeLoading(loading: boolean) {
    this.loading$.next(loading);
  }
}

const tableService = new TableService();
export default tableService;
